// extracted by mini-css-extract-plugin
export var closeButton = "_lt-1";
export var closeX = "_lt-3";
export var container = "_lt-0";
export var image = "_lt-2";